import { Component, OnInit } from '@angular/core';
import { AlertModel, ALERT_TYPE } from '../shared/alert/alert.component';
import { SessionStorageService } from 'src/app/auth/services/session.service';
import { ConsultaEquifaxService } from '../../services/consultaEquifax/consultaEquifax.service';
import { CommonDataService } from 'src/app/services/commons/commondata.service';
import { ProductosList } from 'src/app/models/lists.model';

declare var $: any;

@Component({
  selector: 'app-consulta-equifax',
  templateUrl: './consultaEquifax.component.html',
  styleUrls: ['./consultaEquifax.component.css']
})
export class ConsultaEquifaxComponent implements OnInit {

  public title: string = "CONSULTA MODELO DE RIESGO";
  public loading: boolean = false;
  public alertMessage: AlertModel = new AlertModel;
  public alertConfirmEvent: Function;

  public cuil: string = "";
  public promotor: string = "";
  public producto: string = "";
  public productosList: ProductosList = new ProductosList();
  public promotoresList: any[] = [];
  public showResult: boolean = false;
  public tableResult: any[] = [];

  // Variables del modelo: { claves reales en la respuesta IC -> nombre a mostrar }
  private variablesModeloMap: { keys: string[], label: string }[] = [
    { keys: ['NosisScoVig'], label: 'score_nosis' },
    { keys: ['score_veraz'], label: 'score_veraz' },
    { keys: ['NosisIncomeAvg'], label: 'income_nosis' },
    { keys: ['tc_tenure_ult_compra'], label: 'tenure' },
    { keys: ['bcra_peor_sit_u12m'], label: 'bcra_peor_sit_u12m' },
    { keys: ['peor_sit_bureau_12'], label: 'peor_sit_bureau_u12m' },
    { keys: ['axp_risk_score'], label: 'axp_risk_score' },
    { keys: ['income_avg'], label: 'income_avg' }
  ];

  constructor(
    private consultaEquifaxService: ConsultaEquifaxService,
    private sessionStorageService: SessionStorageService,
    private commonDataService: CommonDataService
  ) {
  }

  ngOnInit() {
    this.loadProductos();
    this.loadPromotores();
  }

  loadProductos() {
    this.commonDataService.getProductos().subscribe(
      data => {
        if (data['code'] == "0" && data['data']) {
          this.productosList.data = Object.assign([], data['data']);
        }
      },
      error => {
        console.error("Error cargando productos", error);
      }
    );
  }

  loadPromotores() {
    this.consultaEquifaxService.getPromotores().subscribe(
      response => {
        if (response.status == 200 && response.body != null && response.body.data) {
          this.promotoresList = Object.assign([], response.body.data);
        }
      },
      error => {
        console.error("Error cargando promotores", error);
      }
    );
  }

  consultar() {
    if (!this.cuil || this.cuil.trim() === '') {
      this.alertMessage = new AlertModel("Debe ingresar un CUIL.", this.title, true, "WARNING");
      return;
    }

    this.loading = true;
    this.showResult = false;
    this.tableResult = [];

    let request = {
      "cuil": this.cuil.trim(),
      "promotor": this.promotor.trim(),
      "producto": this.producto || ""
    };

    this.consultaEquifaxService.consultarEquifax(request).subscribe(
      data => {
        if (data && data['code'] == '0') {
          this.tableResult = [this.mapResultado(data['data'])];
          this.showResult = true;
        } else {
          let msg = data['message'] || "Hubo un inconveniente al consultar el modelo de riesgo.";
          this.alertMessage = new AlertModel(msg, this.title, true, ALERT_TYPE.WARNING);
        }
        this.loading = false;
      },
      error => {
        console.error(error);
        this.alertMessage = new AlertModel("Hubo un inconveniente al consultar el modelo de riesgo.", this.title, true, ALERT_TYPE.ERROR);
        this.loading = false;
      }
    );
  }

  mapResultado(data: any): any {
    if (!data) return {};

    // Extraer nombre de variablesEquifax o variablesNosis
    let nombre = '';
    let genero = '';
    let varEquifax = data.variablesEquifax || {};
    let varNosis = data.variablesNosis || {};
    let variables = data.variables || {};

    // Nombre
    if (varEquifax['nombre']) {
      nombre = varEquifax['nombre'];
    } else if (varNosis['nombre']) {
      nombre = varNosis['nombre'];
    }

    // Género
    if (varEquifax['sexo']) {
      genero = varEquifax['sexo'];
    } else if (varNosis['sexo']) {
      genero = varNosis['sexo'];
    }

    // Estado precheck
    let estadoPrecheck = '';
    if (data.aprobado) {
      estadoPrecheck = 'Cliente sin inconvenientes';
    } else {
      estadoPrecheck = data.explicacion || 'Rechazado';
    }

    // Motivo
    let motivoPrecheck = '';
    if (data.categoriaEquifax) {
      motivoPrecheck = data.categoriaEquifax;
    } else if (data.categoriaNosis) {
      motivoPrecheck = data.categoriaNosis;
    } else if (data.categoria) {
      motivoPrecheck = data.categoria;
    }

    // Fecha de consulta (hoy)
    let hoy = new Date();
    let fecha = this.formatDate(hoy);

    // Combinar todas las fuentes de variables para buscar en todas
    let allVars = { ...varNosis, ...variables, ...varEquifax };
    let variablesModelo = [];

    // Mostramos las variables conocidas del modelo usando el mapeo de claves reales a labels
    for (let item of this.variablesModeloMap) {
      let val = null;
      for (let key of item.keys) {
        if (allVars[key] !== undefined && allVars[key] !== null && allVars[key] !== '') {
          val = allVars[key];
          break;
        }
      }
      if (val !== null) {
        variablesModelo.push({ nombre: item.label, valor: val });
      }
    }

    // Si no encontramos ninguna variable conocida, mostramos todas las que tengan valor
    if (variablesModelo.length === 0) {
      for (let key of Object.keys(allVars)) {
        let val = allVars[key];
        if (val !== null && val !== undefined && val !== '') {
          variablesModelo.push({ nombre: key, valor: val });
        }
      }
    }

    return {
      cuil: this.cuil.trim(),
      nombre: nombre,
      genero: genero,
      fecha: fecha,
      estadoPrecheck: estadoPrecheck,
      motivoPrecheck: motivoPrecheck,
      aprobado: data.aprobado || false,
      variables: variablesModelo,
      expanded: false
    };
  }

  formatDate(date: Date): string {
    let day = date.getDate().toString().padStart(2, '0');
    let month = (date.getMonth() + 1).toString().padStart(2, '0');
    let year = date.getFullYear();
    return day + '/' + month + '/' + year;
  }

  toggleDetalle(index: number) {
    this.tableResult[index].expanded = !this.tableResult[index].expanded;
  }

  limpiar() {
    this.cuil = "";
    this.promotor = "";
    this.producto = "";
    this.showResult = false;
    this.tableResult = [];
  }
}
